import React from 'react';
import { Box, Typography, TextField, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, RadioGroup, Radio } from '@mui/material';

const SEXUAL_ORIENTATIONS = [
  'Gay or Lesbian',
  'Heterosexual/Straight',
  'Bisexual and/or Pansexual and/or Omnisexual',
];

const IdentityForm = ({ campaign, demographics = {}, onChange, disabled }) => {
  const onChangeValue = (key, value) => {
    onChange({
      ...demographics,
      [key]: value,
    });
  };

  const checkboxGroup = (label, options, selectedValues, key) => (
    <>
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>{label}</Typography>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                checked={selectedValues?.includes(option)}
                onChange={(e) => {
                  const newValues = e.target.checked
                    ? [...selectedValues, option]
                    : selectedValues.filter((val) => val !== option);
                  onChangeValue(key, newValues.join(';;;'));
                }}
                disabled={disabled}
              />
            }
            label={option}
          />
        ))}
      </FormGroup>
    </>
  );

  const radioGroup = (label, options, selectedValue, key) => (
    <>
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>{label}</Typography>
      <FormControl component="fieldset">
        <RadioGroup
          value={selectedValue ?? ''}
          onChange={(e) => onChangeValue(key, e.target.value)}
        >
          {options.map((opt) => (
            <FormControlLabel
              key={opt}
              value={opt}
              control={<Radio disabled={disabled} />}
              label={opt}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );

  return (
    <Box>
      {/* Caregiving Status */}
      {campaign.getAskCaregivingStatus?.() && checkboxGroup(
        'Caregiving Status',
        [
          'Responsible for minor children in home',
          'Responsible for care of elderly parents',
          'Responsible for someone with health challenges',
        ],
        demographics.caregivingStatus?.split(';;;') ?? [],
        'caregivingStatus'
      )}

      {/* Gender */}
      {campaign.getAskGender?.() && (
        <>
          {checkboxGroup(
            'Gender',
            [
              'Man',
              'Woman',
              'Non-binary',
              'Transgender',
              'Another term',
            ],
            demographics.gender?.split(';;;') ?? [],
            'gender'
          )}
          {demographics.gender?.split(';;;').includes('Another term') && (
            <TextField
              label="Other Gender"
              fullWidth
              variant="filled"
              value={demographics.otherGender ?? ''}
              onChange={(e) => onChangeValue('otherGender', e.target.value)}
              sx={{ mb: 2 }}
              disabled={disabled}
            />
          )}
        </>
      )}

      {/* Sexual Orientation */}
      {campaign.getAskSexualOrientation?.() && (
        <>
          {radioGroup(
            'Sexual Orientation',
            [...SEXUAL_ORIENTATIONS, 'Another Term'],
            SEXUAL_ORIENTATIONS.includes(demographics.sexualOrientation)
              ? demographics.sexualOrientation
              : demographics.sexualOrientation === null
                ? ''
                : 'Another Term',
            'sexualOrientation'
          )}
          {!SEXUAL_ORIENTATIONS.includes(demographics.sexualOrientation) &&
            demographics.sexualOrientation !== null && (
              <TextField
                label="Sexual Orientation"
                fullWidth
                variant="filled"
                value={demographics.sexualOrientation}
                onChange={(e) => onChangeValue('sexualOrientation', e.target.value)}
                sx={{ mb: 2 }}
                disabled={disabled}
              />
            )}
        </>
      )}
    </Box>
  );
};

export default IdentityForm;
